import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

/**
 * Зберігаємо webView query-параметри ДО того як Angular (withHashLocation)
 * виконає initial navigation і перепише window.location, прибравши search-частину.
 *
 * Логіка збереження:
 * - Якщо `window.location.search` непорожній — це перший запуск з параметрами,
 *   зберігаємо їх у sessionStorage (живуть до закриття вкладки).
 * - Якщо search порожній — нічого не чіпаємо (sessionStorage вже містить попередні
 *   значення або взагалі порожній, що теж коректно).
 */
const rawSearch = window.location.search;
if (rawSearch) {
  sessionStorage.setItem('webview_params', rawSearch);
}

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
